import React, { useState ,useEffect} from "react";
import {
  Empty,Button,Checkbox,Select,Input,Upload,Tooltip,message,TimePicker ,DatePicker,
  Badge,  
} from "antd";
import {
  CaretDownOutlined,
  CaretUpOutlined,
  WarningOutlined,
} from "@ant-design/icons";
import { useNavigate } from "react-router-dom";

import "./rtableSelectable.scss";
import useResumeStore from "../../store/resume.store";
import useJDStore from "../../store/jd.store";
import useExportTemplateStore from "../../store/exportTemplate.store";
import { getFieldStyle } from "../../themes.js";
import useMembersStore from "../../store/members.store";
import FilterPopover from "../../sortingUtils/FilterPopover";
import RTableActionsModal from "../RTableActionsModal/index.jsx";
import * as XLSX from "xlsx";
import axios from "../../helper/axios";
import CommTableActions from "../CommTableActions/index.jsx";
import useStatsStore from "../../store/stats.store.js";
import useSettingstore from "../../store/settings.store";

export default function RTableSelectable({
    isClickable = false,
    automation = false,
    linkActions = false,
    comActions = false,
    titleList,
    data,
    isEditField = false,
    setCurrentView,
    resumeProfileHandler,
    resumeQualityHandler,
    qhjid,
    selectable,
    columnWidth,
    setFilterParameters,
    filterParameters,
    setImportRefreshFlag,
    pullAvailableData = null,
    restorePreviousData = null,
    ignoreUpdateActions = false,
    ignoreDeleteAction  = false,  
    colorData = null,
    viewname = null,
    linkCB = null
}) {
  const { addOrUpdateSetting, getSettingByKey } = useSettingstore();
  const SETTING_KEY = "rtable_frozen_columns";
  const [frozenColumns, setFrozenColumns] = useState(() => {
    const saved = getSettingByKey(SETTING_KEY);
    return saved ? saved.value : 1;
  });

  const navigate = useNavigate();
  const [updateAvailable, setUpdateAvailable] = useState(false);
  const [checkBoxData, setCheckBoxData] = useState([]);
  const {
    updateCandidateStatus,
    resumes,
    allApplications,
    totalapplications,
    handleDownloadAll,
    updateResumeStatus,
    updateInterviewStatus,
    selectedQhrids,
    setSelectedQhrids,
  } = useResumeStore();

  const {totalResumesAutoMatching } = useStatsStore();
  const [isActionModalOpen, setIsActionModalOpen] = useState(false);
  const [isPersistEnabled, setIsPersistEnabled] = useState(() => {
    const saved = localStorage.getItem("persistSelectionsToggle");
    return saved === null ? true : saved === "true";
  });
  const {
    getAllExportTemplate,
    setCurrentExportTemplateArray,
    currentExportTemplateArray,
  } = useExportTemplateStore();

  const handleFreezeChange = (e) => {
    const newValue = parseInt(e.target.value) || 0;

    // Update local UI state
    setFrozenColumns(newValue);

    // Persist to Zustand Store
    addOrUpdateSetting({
      key: SETTING_KEY,
      value: newValue,
    });
  };

  // Persisted selection helpers (store selected qhrids in localStorage)
  const getPersistMap = () =>
    JSON.parse(localStorage.getItem("persistSelections") || "{}");

   useEffect(() => {
        
    const pm = getActiveSelections();
    var setflag = false;
    if (data?.length > 0) {
      data.forEach((d, idx) => {
        if (pm[d.qhid]) {
          setflag = true;
        }
      });
      if (setflag) {
        setUpdateAvailable(true);
      }
      pullAvailableData && pullAvailableData();

      return () => {
        restorePreviousData && restorePreviousData();
      };
    }
  }, [titleList]);
  useEffect(() => {
    const fetchTemplateData = async () => {
      const selectedExportTemplate = localStorage.getItem(
        "selectedExportTemplateID",
      );
      if (selectedExportTemplate && currentExportTemplateArray?.length == 0) {
        const templates = await getAllExportTemplate();
        const currentTemplate = templates?.find(
          (t) => t.templateid == selectedExportTemplate,
        );
        if (currentTemplate?.fields) {
          const newFields = currentTemplate.fields.filter(
            (ele) => ele !== "" && ele !== "TRACKER_HEADING_END",
          );
          setCurrentExportTemplateArray(newFields);
        }
      }
    };
    fetchTemplateData();
  }, []);

  const getActiveSelections = () => {
    if (isPersistEnabled) {
      return JSON.parse(localStorage.getItem("persistSelections") || "{}");
    }
    return selectedQhrids; // From Zustand Store
  };

  const updateSelections = (newIds) => {
    if (isPersistEnabled) {
      localStorage.setItem("persistSelections", JSON.stringify(newIds));
      setSelectedQhrids({}); // Clear store to avoid confusion
    } else {
      setSelectedQhrids(newIds);
      localStorage.removeItem("persistSelections"); // Clear storage
    }
  };

  const toggleSingleSelection = (qhrid, isChecked) => {
    const currentSelections = { ...getActiveSelections() };
    if (isChecked) {
      currentSelections[qhrid] = true;
    } else {
      delete currentSelections[qhrid];
    }
    updateSelections(currentSelections);
    setUpdateAvailable(Object.keys(currentSelections).length != 0);
  };

  
  const { linkAutoResumeMatching } = useStatsStore();
  const [filteredData, setFilteredData] = useState(data);
  const [numericFilters, setNumericFilters] = useState({});
  const [numericFilterResults, setNumericFilterResults] = useState(data);
  const [selectAll, setSelectAll] = useState(false);
  const userData = JSON.parse(localStorage.getItem("userDetails"));
  const handleOk = () => {
    removeSelectedPersisted();
    setIsActionModalOpen(false);
  };

  const handleCancel = () => {
    setIsActionModalOpen(false);
  };

  const numericCols = {
    "Total Exp": "Total Experience",
    "Relevant Exp": "Relevant Experience",
    "Current CTC": "Current CTC",
    ECTC: "ECTC",
    "Notice Period": "Notice Period",
  };

  useEffect(() => {
    const checkBoxArray = data?.map((ele, idx) => {
      return {
        type: "",
        selected: false,
        qhrid: ele.qhid,
        status: ele.candidateStatus,
        candidateComments:ele.candidateComments,
        resumeStatus:ele.resumeStatus,
        resumeComments:ele.resumeComments,
        interviewAction:ele?.iAction,
        interviewType:ele?.iType,
        interviewStatus:ele?.iStatus,
        interviewDate:ele?.iDate,
        interviewTime:ele?.iTime, 
        selectionStatus:ele?.sStatus,          
        documentStatus:ele?.dStatus,    
        bgvStatus:ele?.bgvStatus, 
        isBgvChanged:false,
        isDocuChanged:false,
        isSelectionChanged:false,
        interviewComments:ele?.interviewComments,
        isInterviewCommentsChanged:false,
        selectComments:ele?.selectComments,
        oCTC:ele?.oCTC,
        eDoJ:ele?.eDoJ,  
      };
    });
    setCheckBoxData(checkBoxArray);
    setFilteredData(data);
    
    setNumericFilterResults(data)
  }, [data,totalapplications,totalResumesAutoMatching]);


  const exportAllData =()=>{
      const pivotLayout = JSON.parse(localStorage.getItem("pivotLayout"));
      handleDownloadAll(qhjid, currentExportTemplateArray, pivotLayout, undefined, filterParameters);
  }
  const handleBeforeUpload = async (file) => {
    try {
      const data = await file.arrayBuffer(); // Read file as ArrayBuffer
      const workbook = XLSX.read(data, { type: "array" });
      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];
      const jsonData = XLSX.utils.sheet_to_json(worksheet);

      //console.log("Converted JSON:", jsonData);

      await axios.post(`/updateapplicationsData/${userData.qhoid}/${qhjid}`, {
        resumes: jsonData,
      });
      setImportRefreshFlag((prev) => !prev);
      message.success("Data imported successfully!");
    } catch (error) {
      console.error(error);
      message.error("Failed to import data.");
    }
    return false;
  };
  if ((!data) || data?.length == 0) {
    return (
        <div className="rtable-selectable-btn-wrapper">
        {
              ! linkActions ?
              <>
               {
                 viewname !== "NuJobsReceivedApplications"?<>
                    <div className="rtable-selectable-btn-wrapper-right" style={{margin:"10px"}}>
                        <Tooltip
                          title={
                            <span style={{ color: "black" }}>
                              <WarningOutlined style={{ color: "orange", marginRight: 6 }} />
                              Email is a mandatory field
                            </span>
                          }
                          color="white" // sets tooltip background to white
                        >
                          <Upload
                            accept=".xls,.xlsx,.csv"
                            showUploadList={false}
                            beforeUpload={handleBeforeUpload}
                          >
                            <Button className="rtable-selectable-btn">Import</Button>
                          </Upload>
                        </Tooltip>  
                    </div>                  
                 </>
                 :<></>
               }
              
              </>
              :<>
                  <Empty style={{ margin: "60px" }} >
                      <h4>No Matching Resumes Found</h4>
                  </Empty>               
              </>
        }                             
        </div>
     )
  }
 
  function enableDbUpdate (){
        for(let idx = 0; idx < checkBoxData?.length; idx++){     
            if (checkBoxData[idx]?.selected ) {
                return true
            } 
        }
        return false
  }
  const onCheckBoxChange = (e) => {
        //console.log("check box selected",checkBoxData[e.target.value].selected)
        if (e.target.checked) {
            checkBoxData[e.target.value].selected = true;
            if(resumeQualityHandler != null){
              resumeQualityHandler(data[e.target.value].qhid)
            }                 
        }else{
            checkBoxData[e.target.value].selected = false; 
        }
        if (enableDbUpdate() == true){
            setUpdateAvailable(true)

        }else{
            setUpdateAvailable(false)
        } 
        setCheckBoxData(()=>([...checkBoxData]))
      }

  const handleStatusChange = (value, field, type) => {
        const [idx, status] = value.split('#');
        const idxInt = parseInt(idx);

        setCheckBoxData(prev => {
            const updated = [...prev];
            updated[idxInt] = {
                ...updated[idxInt],
                [field]: status,
                type: type
            };
            return updated;
        });
  };      
  const OnSelectChange = (value) => {
        handleStatusChange(value, "status", "CANDIDATE_STATUS")
  }

  const OnSelectChangeResume = (value) => {
        handleStatusChange(value, "resumeStatus", "RESUME_STATUS");        
  }

  const OnChangeHandlerCandidateStatusComments = (e,idx) => {
      setCheckBoxData(prev => {
            const updated = [...prev];
            updated[idx] = {
                ...updated[idx],
                ['candidateComments']: e.target.value,
                type: "CANDIDATE_STATUS"
            };
            return updated;
      });        
  }
  
  const OnChangeHandlerResumeComments = (e,idx) => {
      setCheckBoxData(prev => {
            const updated = [...prev];
            updated[idx] = {
                ...updated[idx],
                ['resumeComments']: e.target.value,
                type: "RESUME_STATUS"
            };
            return updated;
      });        
  }
  
  const OnChangeHandlerInterviewComments = (e,idx) => {
      setCheckBoxData(prev => {
            const updated = [...prev];
            updated[idx] = {
                ...updated[idx],
                ['interviewComments']: e.target.value,
                ['isInterviewCommentsChanged']:true,
                type: "INTERVIEW_STATUS"
            };
            return updated;
      });          
  }
  
  const OnChangeHandlerSelectionComments = (e,idx) => {
      setCheckBoxData(prev => {
            const updated = [...prev];
            updated[idx] = {
                ...updated[idx],
                ['selectComments']: e.target.value,
                ['isSelectionChanged']:true,
                type: "SELECTION_STATUS"
            };
            return updated;
      });         
  }    

  const OnSelectChangeInterviewType = (value) => {
        handleStatusChange(value, "interviewType", "INTERVIEW_STATUS");   
  } 
    
  const OnSelectChangeInterviewAction = (value) => {
        handleStatusChange(value, "interviewAction", "INTERVIEW_STATUS"); 
  }    
  const OnSelectChangeInterviewStatus = (value) => {
        handleStatusChange(value, "interviewStatus", "INTERVIEW_STATUS");         
  }
  
  const OnSelectChangeSelectionStatus = (value) => {
        const [idx, status] = value.split('#');
        const idxInt = parseInt(idx);
        setCheckBoxData(prev => {
            const updated = [...prev];
            updated[idxInt] = {
                ...updated[idxInt],
                ['selectionStatus']: status,
                ['isSelectionChanged']: true,
                type: "SELECTION_STATUS"
            };
            return updated;
        });         
  }
  
  const OnSelectChangeBGVStatus = (value) => {
        const [idx, status] = value.split('#');
        const idxInt = parseInt(idx);
        setCheckBoxData(prev => {
            const updated = [...prev];
            updated[idxInt] = {
                ...updated[idxInt],
                ['bgvStatus']: status,
                ['isBgvChanged']: true,
                type: "SELECTION_STATUS"
            };
            return updated;
        });        
  }
  const OnSelectChangeDOCUStatus = (value) => {
        const [idx, status] = value.split('#');
        const idxInt = parseInt(idx);
        setCheckBoxData(prev => {
            const updated = [...prev];
            updated[idxInt] = {
                ...updated[idxInt],
                ['documentStatus']: status,
                ['isDocuChanged']: true,
                type: "SELECTION_STATUS"
            };
            return updated;
        });         
  }
  const handleInterviewTime = (rowIndex,time, timeString) =>{
        setCheckBoxData(prev => {
            const updated = [...prev];
            updated[rowIndex] = {
                ...updated[rowIndex],
                ['interviewTime']: timeString,
                type: "INTERVIEW_STATUS"
            };
            return updated;
        });        
  }

  const handleInterviewDate = (rowIndex,Value) =>{
        //console.log("InterviewDate B", rowIndex,Value)
        var day = Value?.$D
        var month = Value?.$M +1
        if(Value?.$D < 10) day = '0'+ Value?.$D
        if(month < 10) month = '0'+ month
        var iDate = ''+day +"-"+ month+"-" + Value?.$y

        setCheckBoxData(prev => {
            const updated = [...prev];
            updated[rowIndex] = {
                ...updated[rowIndex],
                ['interviewDate']: iDate,
                type: "INTERVIEW_STATUS"
            };
            return updated;
        });          
        //console.log("InterviewDate A", checkBoxData[rowIndex].interviewDate)
  }    
  
function getTimeNow(){
        const today = new Date();
        const month = today.getMonth()+1;
        const year = today.getFullYear();
        const date = today. getDate();
        const currentDate = date + "-" + month + "-" + year;
        return currentDate
}

const getUpdated=(rowIndex)=>{
        return checkBoxData?.[rowIndex]?.selected 
}

const handleNumericFilterBtn = (tempNumericFilters) => {
    console.log("Numeric filters to be applied", tempNumericFilters);

    const tempFilterApiParameters = { ...filterParameters };
    
    Object.entries(tempNumericFilters).forEach(([col, { operator, value1, value2 }]) => {
      const hasValue1 = value1 !== "";
      const hasValue2 = value2 !== "";
      
      if (hasValue1) {
        const filterValue = hasValue2 
          ? `${operator}${value1} and ${value2}`
          : `${operator}${value1}`;
        
        tempFilterApiParameters[numericCols[col]] = filterValue;
      }
    });
    console.log(tempFilterApiParameters, "Numeric Filter API Parameters");
    setFilterParameters(tempFilterApiParameters);
  };



    const handleResumeDetailClick = (id,qhID) => {
      if(automation){
         navigate(`/resumeDataBase/${qhID}`)
      }else{
        var view = "profile"
        if(resumeProfileHandler !=null){
          resumeProfileHandler(qhjid,id, qhID,)
          setCurrentView(view)
          navigate(`candidateProfile/${id}/${qhID}/${view}`, { state: { jdID: qhjid } });
        }
      }
    }   
  const handleSelectAll = () => {
    const tempCheckBoxData = [...checkBoxData];
    if (selectAll) {
      tempCheckBoxData.forEach((item) => {
        item.selected = false;
      });
      setCheckBoxData(tempCheckBoxData);
      setUpdateAvailable(false);
    } else {
      tempCheckBoxData.forEach((item) => {
        item.selected = true;
      });
      setCheckBoxData(tempCheckBoxData);
      setUpdateAvailable(true);
    }
    setSelectAll(!selectAll);
  };


  const setPersistMap = (map) =>
    localStorage.setItem("persistSelections", JSON.stringify(map));

  const togglePersistForQhrid = (qhrid, value) => {
    const map = getPersistMap();
    if (value) map[qhrid] = true;
    else delete map[qhrid];
    setPersistMap(map);
  };

  const exportSelectedPersisted = () => {
    const pivotLayout = JSON.parse(localStorage.getItem("pivotLayout"));

    // persisted selections (may include qhrids from other pages)
    const persistMap = getActiveSelections() || {};
    const persistedQhrids = Object.keys(persistMap).filter(
      (k) => persistMap[k],
    );

    // selected items on current page (from checkBoxData)
    const currentPageSelected = (checkBoxData || [])
      .map((c, idx) => (c?.selected ? data?.[idx]?.qhid : null))
      .filter(Boolean);

    // merge and dedupe
    const mergedSelected = Array.from(new Set([...persistedQhrids, ...currentPageSelected]));

    console.log("Selected QHRIDs (merged across pages):", mergedSelected);

    handleDownloadAll(qhjid, currentExportTemplateArray, pivotLayout, mergedSelected, filterParameters);
  };

  const removeSelectedPersisted = () => {
    // Build encoded JSON similar to encodeJsonRemoveReq but using merged selection
    const map = getActiveSelections();
    const encodedJsonValues = {
      _id: "Not used",
      qhglobaljid: "Not USed",
      qhoid: userData.qhoid,
      accounttype: userData.account_type,
      qhjid: qhjid,
      deletelist: [],
    };
    let num = 0;
    (data || []).forEach((d, idx) => {
      if ((checkBoxData?.[idx]?.selected) || map[d.qhid]) {
        encodedJsonValues.deletelist[num] = { qhrid: d.qhid };
        num++;
      }
    });
    const newDate = getTimeNow();
    encodedJsonValues.updatetype = "DELETE_RESUME";
    encodedJsonValues.updatedby = userData.qhuid;
    encodedJsonValues.updatedbyname = userData.username;
    encodedJsonValues.updatedon = newDate;

    updateCandidateStatus({
      jasonValues: encodedJsonValues,
      qhjid,
    });

    // clear these selections from persisted map and state
    const pm = getActiveSelections();
    (data || []).forEach((d, idx) => {
      if (pm[d.qhid]) delete pm[d.qhid];
      if (checkBoxData?.[idx]) checkBoxData[idx].selected = false;
    });
    setPersistMap(pm);
    setCheckBoxData(() => [...checkBoxData]);
    setUpdateAvailable(false);
  };


  const linkJDActions= () => {
    const map = getActiveSelections();
    const encodedJsonValues = {
      linkedresumesinfo: [],
    };

    let candNum = 0;
    let cbcs = false;

    (data || []).forEach((d, idx) => {
      const selected = (checkBoxData?.[idx]?.selected) || map[d.qhid];
      if (!selected) return;
      const cb = checkBoxData?.[idx] || {};
      cbcs = true
      encodedJsonValues.linkedresumesinfo[candNum] = {
          qhrid: d.qhid,
          mobile: d.mobile,
          email: d.email
        };
      candNum++;   
    });

    const newDate = getTimeNow();
    encodedJsonValues.updatedby = userData.qhuid;
    encodedJsonValues.updatedbyname = userData.username;
    encodedJsonValues.updatedon = newDate;
    if (cbcs === true){
      linkAutoResumeMatching({
        jasonValues: encodedJsonValues,
        qhjid,
        linkCB
      });
    }

    // clear persisted selections that were updated and reset checkboxes
    const pm = getActiveSelections();
    (data || []).forEach((d, idx) => {
      if (pm[d.qhid]) delete pm[d.qhid];
      if (checkBoxData?.[idx]) checkBoxData[idx].selected = false;
    });
    setPersistMap(pm);
    setSelectedQhrids({});
    setCheckBoxData(() => [...checkBoxData]);
    setUpdateAvailable(false);
  }

  const updateSelectedPersisted = () => {
    // Build encoded JSON similar to encodeJson but using merged selections and available checkBoxData fields
    const map = getActiveSelections();
    const encodedJsonValues = {
      _id: "Not used",
      qhglobaljid: "Not USed",
      qhoid: userData.qhoid,
      accounttype: userData.account_type,
      qhjid: qhjid,
      candidatelist: [],
      resumelist: [],
      interviewlist:[],
      selectionlist:[],
      bgvlist:[],
      documentslist:[],
      isselectionchanged:false,
      isBgvChanged:false,
      isDocuChanged:false,
    };

    let candNum = 0;
    let resNum = 0;
    let intvNum = 0;
    let selNum = 0;
    let cbcs = false;
    let rscs = false;
    let iscs = false;
    let slcs = false;

    (data || []).forEach((d, idx) => {
      const selected = (checkBoxData?.[idx]?.selected) || map[d.qhid];
      if (!selected) return;

      const cb = checkBoxData?.[idx] || {};

      if (cb.type === "CANDIDATE_STATUS") {
        cbcs = true
        encodedJsonValues.candidatelist[candNum] = {
          qhrid: d.qhid,
          status: cb.status,
          comments:cb.candidateComments,
        };
        candNum++;
      }
      if (cb.type === "RESUME_STATUS") {
        rscs = true
        encodedJsonValues.resumelist[resNum] = {
          qhrid: d.qhid,
          status: cb.resumeStatus,
          comments: cb.resumeComments,
        };
        resNum++;
      }

      if (cb.type === "INTERVIEW_STATUS") {
        iscs = true
        encodedJsonValues.interviewlist[intvNum] = {
          qhrid: d.qhid,
          status: cb.interviewStatus,
          type: cb.interviewType,
          action: d.interviewAction,
          interviewdate: cb.interviewDate,
          interviewtime: cb.interviewTime,          
          comments: cb.interviewComments,        
        };
        intvNum++;
      } 
      if (cb.type === "SELECTION_STATUS") {
        slcs = true
        //console.log("SELECTION STATUS", cb.isDocuChanged, "New status:", cb.documentStatus)
        if(cb.isSelectionChanged){
          encodedJsonValues.isselectionchanged= true
          encodedJsonValues.selectionlist[selNum] = {
            qhrid: d.qhid,
            status: cb.selectionStatus,
            edoj: cb.eDoJ,
            octc: cb.oCTC,
            comments: cb.selectComments,             
          };
        }
        if(cb.isBgvChanged){
          encodedJsonValues.isBgvChanged= true
          encodedJsonValues.bgvlist[selNum] = {
            qhrid: d.qhid,
            status: cb.bgvStatus,           
          };
        }    
        if(cb.isDocuChanged){
          //console.log("Document changed for ", d.qhid, "New status:", cb.documentStatus)
          encodedJsonValues.isDocuChanged= true
          encodedJsonValues.documentslist[selNum] = {
            qhrid: d.qhid,
            status: cb.documentStatus,           
          };
        }              
        selNum++;
      }       
    });

    const newDate = getTimeNow();
    encodedJsonValues.updatedby = userData.qhuid;
    encodedJsonValues.updatedbyname = userData.username;
    encodedJsonValues.updatedon = newDate;

    if (cbcs === true){
      encodedJsonValues.updatetype = "CANDIDATE_STATUS";      
      updateCandidateStatus({
        jasonValues: encodedJsonValues,
        qhjid,
      });
    } 
    if (rscs == true){
      encodedJsonValues.updatetype = "RESUME_STATUS";
      updateResumeStatus({
        jasonValues: encodedJsonValues,
        qhjid,
      });
    } 
    if (iscs == true){
      encodedJsonValues.updatetype = "INTERVIEW_STATUS";      
      updateInterviewStatus({
        jasonValues: encodedJsonValues,
        qhjid,
      });
    }
    if (slcs == true){    
      encodedJsonValues.updatetype = "SELECTION_STATUS"; 
      updateInterviewStatus({
        jasonValues: encodedJsonValues,
        qhjid,
      });
    }

    // clear persisted selections that were updated and reset checkboxes
    const pm = getActiveSelections();
    (data || []).forEach((d, idx) => {
      if (pm[d.qhid]) delete pm[d.qhid];
      if (checkBoxData?.[idx]) checkBoxData[idx].selected = false;
    });
    setPersistMap(pm);
    setSelectedQhrids({});
    setCheckBoxData(() => [...checkBoxData]);
    setUpdateAvailable(false);
  };

  const handleTogglePersistence = (checked) => {
    const currentData = getActiveSelections(); // Get data before switching
    setIsPersistEnabled(checked);
    localStorage.setItem("persistSelectionsToggle", checked.toString());

    // Migrate the data to the new storage type
    if (checked) {
      localStorage.setItem("persistSelections", JSON.stringify(currentData));
      setSelectedQhrids({});
    } else {
      setSelectedQhrids({});
      localStorage.removeItem("persistSelections");
    }
  };

  const handleSelectAllPersisted = () => {
    // Toggle current selectAll state and persist selection for all qhrids on current page
    handleSelectAll(); // will toggle checkBoxData and selectAll
    const willSelect = !selectAll;
    const currentPageIds = (data || []).map((d) => d.qhid);
    const currentActiveMap = getActiveSelections();

    if (willSelect) {
      currentPageIds.forEach((id) => {
        currentActiveMap[id] = true;
      });
    } else {
      currentPageIds.forEach((id) => {
        delete currentActiveMap[id];
      });
    }

    updateSelections(currentActiveMap);
    setSelectAll(willSelect);
  };



  const handleEmailCleanups = (value) => {
        setUpdateAvailable(false);
        setSelectAll(false);
  }

  const buildOptions = (list, rowIndex) =>
    list.map((item) => ({
      value: `${rowIndex}#${item}`,
      label: item,
    }));  

  const resumeStatusList = [
    "NA",
    "Shared",
    "Review Pending",
    "Feedback Pending",
    "Client Feedback Pending",
    "To Be Shared",
    "Screen Rejected",
    "Screen Rejected HCTC",
    "Screen Rejected HNP",
    "Duplicate",
    "Interview Rejected",
    "Screen Selected",
    "Screen Partial Suitable",
  ];

  const callStatusList = [
    "Not Picking",
    "Busy",
    "Call Later",
    "Not Interested",
    "Not Looking",
    "Not Suitable",  
    "Resume Pending",      
    "Location Issue",
    "JD Needed",
    "Direct Payroll",
    "Disconnected",
    "OOS",
    "SwitchOFF",
    "Already Got Call",
    "Already Applied",
    "Interview within 6 Months",
    "Interview before 6 months",
    "To Be Called",
    "Available"
];
  const iTypeList = [
    "L0",
    "L1",
    "L2",
    "Customer",
    "HR",
    "MgMT",
  ];
  const iActionList = [
    "Schedule",
    "Reschedule",
    "Cancel",
  ];
  const iStatusList = [
    "NA",
    "YTBS",
    "YTBRS",
    "Scheduled",
    "Rescheduled",
    "Cancelled",
    "IFP",
    "No Panel",
    "Candidate Drop", 
    "Candidate NP",
    "Panel Not Joined",
    "Candidate No Show",
    "Candidate On Hold",
    "Rejected",
    "Selected",
    "Final Select",
  ];
  const sStatusList = [
    "Offer Pending",
    "Offered",
    "Declined",
    "Joined",
    "Hold",
    "Accepted",
  ];
 
  const dStatusList = [
    "Documents Not OK",
    "Documents OK",
    "Documents Pending",
  ];
 
  const bgvStatusList = [
    "BGV Ongoing",
    "BGV Fail",
    "BGV OK",
  ];

  const getStickyStyle = (index, cellType) => {
    if (index >= frozenColumns) return {};

    // Calculate sum of widths of all previous columns to set the 'left' property
    const leftOffset = columnWidth
      .slice(0, index)
      .reduce((acc, curr) => acc + curr, 0);

    return {
      position: "sticky",
      left: `${leftOffset}px`,
      zIndex: 10,
      backgroundColor: cellType === "title" ? "#99d2fd" : "#c0e4ff",
      boxShadow:
        index === frozenColumns - 1 ? "2px 0 5px -2px rgba(0,0,0,0.2)" : "none", // Adds a nice shadow line
    };
  };

  const gridTemplate = columnWidth.map((w) => `${w}px`).join(" ");

  const handleChangeInApplications= (tableInfo)=>{
        const [idx, changed] = tableInfo?.toString().split('#');
        //console.log("table info", tableInfo, "Change detected in row index:", idx, "Changed field:", changed);
        if((changed ==="true")&&(changed !=undefined)) return true 
        return false
  }
  const getIDx= (tableInfo)=>{
        const [idx, changed] = tableInfo?.toString().split('#');
        const idxInt = parseInt(idx);
        return idxInt
  }  
  return (
    <div className="resume-rtable-selectable-wrapper">
      <RTableActionsModal
        isModalOpen={isActionModalOpen}
        handleOk={handleOk}
        handleCancel={handleCancel}
        action={"Delete"}
        actionMessage={"Delete Resume(s)?"}
      />
      <div className="rtable-selectable-btn-wrapper">
        <div className="rtable-selectable-btn-wrapper-left">
	      <div
	        className="freeze-control"
	        style={{ marginBottom: "10px", position: "sticky", left: "0" }}
	      >
	        <span style={{ fontSize: "14px" }}>Freeze Columns: </span>
	        <input
	          type="number"
	          min="0"
	          max={titleList.length}
	          value={frozenColumns}
	          onChange={handleFreezeChange}
	          style={{
	            width: "50px",
	            marginLeft: "4px",
	            borderRadius: "6px",
	            border: "1px solid #ccc",
	          }}
	        />
	      </div>
          {isEditField ? (
          <>
            <div className="rtable-selectable-btn-wrapper-right">
              {
                comActions === true?
                <CommTableActions handleEmailCleanups={handleEmailCleanups} 
                                  updateAvailable={updateAvailable} data={data} checkBoxData={checkBoxData} qhjid={qhjid}/>
                :
                <>
                   {
                      ignoreUpdateActions===false?
                      <>
                        <Button
                            className="rtable-selectable-btn"
                            disabled={!updateAvailable}
                            onClick={linkActions ? linkJDActions : updateSelectedPersisted}
                        >
                          {linkActions ? "Link JD" : "Update Status"}
                        </Button>
                        {
                          linkActions===true || ignoreDeleteAction?
                          <></>
                          :<>
                            <Button
                                className="rtable-selectable-btn"
                                disabled={!updateAvailable}
                                onClick={() => setIsActionModalOpen(true)}
                            >
                              Remove Resume
                            </Button>                           
                          </>
                        }                      
                      </>
                      :<></>
                   }
                   {
                    linkActions === false?
                    <>
                      <Button
                        className="rtable-selectable-btn"
                        disabled={!updateAvailable}
                          onClick={exportSelectedPersisted}
                      >
                        Export selected data
                    </Button>
                    <Button className="rtable-selectable-btn" onClick={exportAllData}>
                        Export All
                    </Button>  
                    {
                      viewname !== "NuJobsReceivedApplications"?
                      <>
                        <Tooltip
                          title={
                            <span style={{ color: "black" }}>
                              <WarningOutlined style={{ color: "orange", marginRight: 6 }} />
                              Email is a mandatory field
                            </span>
                          }
                          color="white" // sets tooltip background to white
                          >
                          <Upload
                            accept=".xls,.xlsx,.csv"
                            showUploadList={false}
                            beforeUpload={handleBeforeUpload}
                          >
                            <Button className="rtable-selectable-btn">Import</Button>
                          </Upload>
                        </Tooltip>  
                      </>
                      :<></>
                    }                                     
                    </>
                    :<></>
                   }               
                </>
              }
            </div>                    
          </>)
          :<></>
        }
        </div>
        <div className="rtable-selectable-btn-wrapper-right">
          <Checkbox
            checked={isPersistEnabled}
            onChange={(e) => handleTogglePersistence(e.target.checked)}
          >
            Persist Selections
          </Checkbox>
        </div>
      </div>
      <div
        className="rtable-title-wrapper"
        style={{
          gridTemplateColumns: gridTemplate,
        }}
      >
        {titleList.map((title, idx) => {
          return (
            <div
              key={`${title}-${idx}`}
              className="rtable-title"
              style={getStickyStyle(idx, "title")}
            >
              {title === "Select" ? (
                <Checkbox
                  className="rtable-title-checkbox"
                  style={{ cursor: "pointer" }}
                  onClick={() => handleSelectAllPersisted()}
                  checked={selectAll}
                ></Checkbox>
              ) : (
                <p className="rtable-title-text">{title}</p>
              )}

              {numericCols[title] && (
                <FilterPopover
                  columnKey={title}
                  currentFilter={numericFilters[title]}
                  onFilterChange={(col, filter) => {
                    let tempData = { ...numericFilters, [col]: filter };
                    handleNumericFilterBtn(tempData);
                    setNumericFilters((f) => ({ ...f, [col]: filter }));
                  }}
                />
              )}
            </div>
          );
        })}
      </div>

      {numericFilterResults?.map((table, rowIndex) => {
        const persistMap = getActiveSelections();
        const isSelected =
          (persistMap[table.qhid] || getUpdated(rowIndex)) === true ||
          selectedQhrids[table.qhid];
        return (
                <div
                    key={`${getIDx(table.id)}-${titleList.join("-")}-${rowIndex}`}
                    className="rtable-info-wrapper"
                    style={{
                    gridTemplateColumns: gridTemplate,
                    }}
                >
                    {Object.keys(table)?.map((tableInfo, idx) => (                    
                    <div
                      className={`rtable-info ${tableInfo == "name" ? "is-link" : ""}`}
                      style={{
                        ...(checkBoxData[rowIndex]?.selected
                          ? { cursor: isClickable && "pointer" }
                          : { 
                              ...getFieldStyle(tableInfo, table[tableInfo]),
                              cursor: isClickable && "pointer",
                            }),
                        ...getStickyStyle(idx, "info"),
                         cursor: tableInfo == "name" ? "pointer" : "auto",
                        ...(getFieldStyle(tableInfo, table[tableInfo]) === undefined && colorData && {
                          backgroundColor: colorData?.[rowIndex]?.color,
                        }),
                      }}
                      onClick={() =>
                        tableInfo == "name"
                          ? handleResumeDetailClick(getIDx(table.id), table.qhid)
                          : ""
                      }
                    >
                    {tableInfo === "select" ? (
                      <Checkbox
                        className="checkbox-wrapper"
                        value={rowIndex}
                    checked={getActiveSelections()[table.qhid]}
                    onChange={(e) => {
                      onCheckBoxChange(e);
                      toggleSingleSelection(table.qhid, e.target.checked);
                    }}
                  />
                    ) : (
                      <></>
                    )}
			
                            {isEditField ? (
                                <div className="edit-field-wrapper">
                                        <>
                                            {
                                               tableInfo === "id"
                                                ?(
                                                  <>
                                                    { handleChangeInApplications(table[tableInfo])?
                                                      <Badge
                                                        count="***"
                                                        style={{
                                                          backgroundColor: "#5fb0f6",
                                                          fontSize: 8,
                                                          height: 14,
                                                          minWidth: 14,
                                                          lineHeight: "14px",
                                                          padding: "0 4px",
                                                        }}
                                                        offset={[15,-2]}
                                                      >
                                                            <span
                                                              style={{
                                                                fontSize: "10px",      // your normal font size
                                                                fontWeight: "500",  // or 500/600 as needed
                                                                lineHeight: "normal",
                                                              }}
                                                            >
                                                              {getIDx(table[tableInfo])}
                                                            </span>
                                                      </Badge>                                                        
                                                        :
                                                        <>
                                                           {getIDx(table[tableInfo])}
                                                        </>
                                                       
                                                      }
                                                 </>
                                                )                                                                                          
                                               :tableInfo === "select"
                                                ? table[tableInfo]
                                               :tableInfo === "name"
                                                ? table[tableInfo]                                         
                                               :tableInfo === "candidateStatus" ? (
                                                    <>
                                                        {isSelected === true && selectable === "C Only"?
                                                        <Select
                                                          style={{ width: 130, height: 24 }}
                                                          onChange={(OnSelectChange)}
                                                          placeholder={checkBoxData[rowIndex]?.status}
                                                          options={buildOptions(callStatusList, rowIndex)}
                                                        />                                                         :
                                                        table[tableInfo]==""?"--":table[tableInfo]}    
                                                    </> 
                                               )                                             
                                               : tableInfo === "resumeStatus" ? (
                                                    <>
                                                        {isSelected === true && selectable === "R Only"?
                                                        <Select
                                                          style={{ width: 130, height: 24 }}
                                                          onChange={OnSelectChangeResume}
                                                          placeholder={table[tableInfo]}
                                                          options={buildOptions(resumeStatusList, rowIndex)}
                                                        /> :
                                                        table[tableInfo]==""?"--":table[tableInfo]}    
                                                    </> 
                                               )                                             
                                               : tableInfo === "candidateComments" ? (
                                                    <>
                                                        {isSelected === true?
                                                          <Input
                                                              style={{ width: 180,height: 30 ,textAlign: 'left'}}
                                                              onChange = {(value)=>OnChangeHandlerCandidateStatusComments(value, rowIndex)}
                                                              defaultValue={table[tableInfo]} 
                                                          />
                                                        :
                                                        checkBoxData[rowIndex]?.candidateComments==""?"--":checkBoxData[rowIndex]?.candidateComments}    
                                                    </> 
                                               )  
                                               : tableInfo === "resumeComments" ? (
                                                    <>
                                                        {isSelected === true?
                                                          <Input
                                                              style={{ width: 130,height: 30 ,textAlign: 'left'}}
                                                              onChange = {(value)=>OnChangeHandlerResumeComments(value, rowIndex)}
                                                              defaultValue={table[tableInfo]} 
                                                          />
                                                        :
                                                        checkBoxData[rowIndex]?.resumeComments==""?"--":checkBoxData[rowIndex]?.resumeComments}    
                                                    </> 
                                               )                                               
                                               : tableInfo === "iType" ? (
                                                    <>
                                                        {isSelected === true?                                                      
                                                        <Select
                                                            style={{ width: 130,height: 24 }}
                                                            onChange={OnSelectChangeInterviewType}
                                                            placeholder={table[tableInfo]} 
                                                            options={buildOptions(iTypeList, rowIndex)}
                                                        /> :
                                                        table[tableInfo]==""?"--":table[tableInfo]}   
                                                    </> 
                                               ) 
                                               : tableInfo === "iAction" ? (
                                                    <>
                                                        {isSelected === true?
                                                        <Select
                                                            style={{ width: 130,height: 24 }}
                                                            onChange={OnSelectChangeInterviewAction}
                                                            placeholder="Select" 
                                                            options={buildOptions(iActionList, rowIndex)}                                                      
                                                        /> :
                                                        table[tableInfo]==""?"--":table[tableInfo]}    
                                                    </> 
                                               )     
                                               : tableInfo === "iStatus" ? (
                                                    <>
                                                        {isSelected === true?
                                                        <Select
                                                            style={{ width: 130,height: 24 }}
                                                            onChange={OnSelectChangeInterviewStatus}
                                                            placeholder={table[tableInfo]}   
                                                            options={buildOptions(iStatusList, rowIndex)}                                                         
                                                        /> :
                                                        table[tableInfo]==""?"--":table[tableInfo]}    
                                                    </> 
                                               ) 
                                               : tableInfo === "sStatus" ? (
                                                    <>
                                                        {isSelected === true?
                                                        <Select
                                                            style={{ width: 130,height: 24 }}
                                                            onChange={OnSelectChangeSelectionStatus}
                                                            placeholder={table[tableInfo]}   
                                                            options={buildOptions(sStatusList, rowIndex)}                                                              
                                                        /> :
                                                        table[tableInfo]==""?"--":table[tableInfo]}      
                                                    </> 
                                               ) 
                                             : tableInfo === "dStatus" ? (
                                                    <>
                                                        {isSelected === true?
                                                        <Select
                                                            style={{ width: 130,height: 24 }}
                                                            onChange={OnSelectChangeDOCUStatus}
                                                            placeholder={table[tableInfo]}  
                                                            options={buildOptions(dStatusList, rowIndex)}                                                              
                                                        /> :
                                                        table[tableInfo]==""?"--":table[tableInfo]}    
                                                    </> 
                                               ) 
                                              : tableInfo === "bgvStatus" ? (
                                                    <>
                                                        {isSelected === true?
                                                        <Select
                                                            style={{ width: 130,height: 24 }}
                                                            onChange={OnSelectChangeBGVStatus}
                                                            placeholder={table[tableInfo]} 
                                                            options={buildOptions(bgvStatusList, rowIndex)}                                                                
                                                        /> :
                                                        table[tableInfo]==""?"--":table[tableInfo]}       
                                                    </> 
                                               )   
                                              : tableInfo === "interviewComments" ? (
                                                    <>
                                                        {isSelected === true?
                                                          <Input
                                                              style={{ height: 25,textAlign: 'left'}}
                                                              onChange = {(value)=>OnChangeHandlerInterviewComments(value, rowIndex)}
                                                              defaultValue={table[tableInfo]} 
                                                          />
                                                        :
                                                        table[tableInfo]==""?"--":table[tableInfo]}    
                                                    </> 
                                               ) 
                                              : tableInfo === "selectComments" ? (
                                                    <>
                                                        {isSelected === true?
                                                          <Input
                                                              style={{ width: 130,height: 25 }}
                                                              onChange = {(value)=>OnChangeHandlerSelectionComments(value, rowIndex)}
                                                              defaultValue={table[tableInfo]} 
                                                          />
                                                        :
                                                        table[tableInfo]==""?"--":table[tableInfo]}    
                                                    </> 
                                               )  
                                               : tableInfo === "iTime" ? (
                                                    <>
                                                        {isSelected === true?
                                                        <TimePicker   
                                                                     use12Hours={true}
                                                                     format={"h:mm a"}
                                                                     style={{ width: 130,height: 24 }}
                                                                     onChange={(time,timeString)=>handleInterviewTime(rowIndex,time,timeString)}
                                                        />:
                                                        table[tableInfo]==""?"--":table[tableInfo]}   
                                                    </> 
                                               )  
                                              : tableInfo === "iDate" ? (
                                                    <>
                                                        {isSelected === true?
                                                        <DatePicker 
                                                                style={{ width: 130,height: 24 }}
                                                                onChange={(value)=>handleInterviewDate(rowIndex,value)}
                                                        />:
                                                        table[tableInfo]==""?"--":table[tableInfo]}     
                                                    </> 
                                               )                                                                                                                                                                                                                                                                                                                                                                                                                                                                               
                                               : table[tableInfo]==""?"--":table[tableInfo]
                                            }                                                                                                                                                                                                                                                                               
                                        </>

                                </div>
                            ) : (                               
                                table[tableInfo]=="" && tableInfo !="select"?"--":
                                tableInfo=="id"?
                                      <>
                                                    { handleChangeInApplications(table[tableInfo])?
                                                      <Badge
                                                        count="***"
                                                        style={{
                                                          backgroundColor: "#5fb0f6",
                                                          fontSize: 8,
                                                          height: 14,
                                                          minWidth: 14,
                                                          lineHeight: "14px",
                                                          padding: "0 4px",
                                                        }}
                                                        offset={[15,-2]}
                                                      >
                                                            <span
                                                              style={{
                                                                fontSize: "10px",      // your normal font size
                                                                fontWeight: "500",  // or 500/600 as needed
                                                                lineHeight: "normal",
                                                              }}
                                                            >
                                                              {getIDx(table[tableInfo])}
                                                            </span>
                                                      </Badge>                                                        
                                                        :
                                                        <>
                                                           {getIDx(table[tableInfo])}
                                                        </>
                                                       
                                                      }
                                                 </>
                                   :table[tableInfo]
                            )}
                    </div>
                    ))}
                </div>
        );
       })}
    </div>
    )
}